import type { AxiosResponse } from "axios";
import { InitService } from "./init.service";
import type Item from "./model/item";

export class UfService extends InitService {
    public obterUfs(): Promise<AxiosResponse<Array<Item>>> {
        return this.get('MunicipioUf/ObterUfs/', true);
    }
}

const ufService = new UfService();

export default ufService;